import storage from 'good-storage'

const loginStatusKey = 'loginStatus'     //登录态 0 1
const studentKey = 'student'
const roomsKey = 'rooms'
const teachersKey = 'teachers'
const adminKey = 'admin'
const SESSION_KEY = '_session'

export function loadLoginStatus () {
  return storage.session.get(loginStatusKey) || 0
}

export function saveLoginStatus (status) {
  storage.session.set(loginStatusKey, status)
  return status
}

export function loadStudent () {
  return storage.session.get(studentKey, {})
}

export function saveStudent (student) {
  storage.session.set(studentKey, student)
  return student
}

export function loadRooms () {
  return storage.session.get(roomsKey, {})
}

export function saveRooms (rooms) {
  storage.session.set(roomsKey, rooms)
  return rooms
}

export function loadTeachers () {
  return storage.session.get(teachersKey, {})
}

export function saveTeachers (teachers) {
  storage.session.set(teachersKey, teachers)
  return teachers
}

export function loadAdmin () {
  return storage.session.get(adminKey, {})
}

export function saveAdmin (admin) {
  storage.session.set(adminKey, admin)
  return admin
}

export const setSessionData = (key, value) => {
  let session = storage.session.get(SESSION_KEY, {})
  session[key] = value
  storage.session.set(SESSION_KEY, session)
}

export const getSessionData = (key, defaultValue) => {
  let session = storage.session.get(SESSION_KEY, {})
  return Object.prototype.hasOwnProperty.call(session, key) ? session[key] : defaultValue
}

export const removeSessionData = key => {
  let session = storage.session.get(SESSION_KEY, {})
  delete session[key]
  storage.session.set(SESSION_KEY, session)
}

export const clearSessionData = () => {
  storage.session.remove(SESSION_KEY)
}

// 持久化登录凭据（localStorage，关闭浏览器后仍然保留）
const persistentStudentKey = 'persistentStudent'
const persistentPartnerKey = 'persistentPartner'
const persistentLoginStatusKey = 'persistentLoginStatus'
const persistentLoginPageKey = 'persistentLoginPage'

export function savePersistentStudent (student) {
  storage.set(persistentStudentKey, student)
}

export function loadPersistentStudent () {
  return storage.get(persistentStudentKey, null)
}

export function clearPersistentStudent () {
  storage.remove(persistentStudentKey)
}

export function savePersistentPartner (partner) {
  storage.set(persistentPartnerKey, partner)
}

export function loadPersistentPartner () {
  return storage.get(persistentPartnerKey, '')
}

export function clearPersistentPartner () {
  storage.remove(persistentPartnerKey)
}

export function savePersistentLoginStatus (status) {
  storage.set(persistentLoginStatusKey, status)
}

export function loadPersistentLoginStatus () {
  return storage.get(persistentLoginStatusKey, 0)
}

export function clearPersistentLoginStatus () {
  storage.remove(persistentLoginStatusKey)
}

export function savePersistentLoginPage (loginPage) {
  storage.set(persistentLoginPageKey, loginPage)
}

export function loadPersistentLoginPage () {
  return storage.get(persistentLoginPageKey, 'login')
}

export function clearPersistentLoginPage () {
  storage.remove(persistentLoginPageKey)
}

export function clearAllPersistent () {
  clearPersistentStudent()
  clearPersistentPartner()
  clearPersistentLoginStatus()
  clearPersistentLoginPage()
}
